import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext } from "react"
import { CalendarContext } from "../context"
import cal from "clsx"
import { AdPlace } from "Types/place"
import { BoardAction, BoardModifyDialog } from "Types/board"

const useStyles = makeStyles(() => ({
    content: {
        borderLeft: "1px solid #ddd",
        display: "flex",
        flexGrow: 1,
        position: "relative",
    },
    select: {
        cursor: "move",
    },
}))
interface ComponentProps {
    place: AdPlace,
    children?: React.ReactNode,
    toggle: (value: boolean) => void
}
const CalendarContent = (props: ComponentProps) => {
    const { place, children, toggle } = props
    const classes = useStyles()
    const {
        privilege, selectPlaceId,
        handleChangeBoardModifyDialog, boardModifyDialog,
        isWeChat, isWeibo,
    } = useContext(CalendarContext)
    const handleEndSelect = () => {
        if (!privilege.insert) {
            return
        }
        if (selectPlaceId) {
            toggle(false)
            let type: BoardAction = "multiple_create"
            if (isWeibo) {
                type = "weibo_multiple_create"
            } else if (isWeChat) {
                type = "wechat_multiple_create"
            }
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                type,
                place,
            })
        }
    }
    const handleMouseLeave = () => {
        if (selectPlaceId) {
            handleEndSelect()
        }
    }
    return (
        <div
            className={cal(
                classes.content,
                selectPlaceId !== 0 && classes.select,
            )}
            onMouseUp={handleEndSelect}
            onMouseLeave={handleMouseLeave}
        >
            {children}
        </div>
    )
}

export default CalendarContent
